import React from "react";
import { Link, IndexLink } from "react-router";
import { FormattedMessage } from "react-intl";
import userHasAccess from "../../../utils/userHasAccess";
import {
  FINANCE,
  DIRECTOR,
  MANAGER,
  ADMINISTRATOR,
  FINTECH,
} from "../../../utils/Roles";

const menus = [
  {
    condition: () => userHasAccess([ADMINISTRATOR, FINTECH, DIRECTOR, MANAGER], true),
    to: "/dashboard/transfer/import",
    title: "importExport.pages.importMembers",
  },
  {
    condition: () => userHasAccess([ADMINISTRATOR, FINTECH, DIRECTOR, MANAGER], true),
    index: true,
    to: "/dashboard/transfer/export",
    title: "importExport.pages.exports",
  },
  {
    condition: () => userHasAccess([FINANCE, ADMINISTRATOR, FINTECH], true),
    index: true,
    to: "/dashboard/transfer/accounting-exports",
    title: "importExport.pages.accountingExports",
  },
  {
    condition: () => userHasAccess([MANAGER, FINANCE, DIRECTOR]),
    to: "/dashboard/transfer/suppliers-reports",
    title: "importExport.pages.reports",
  },
];

const ImportExportNav = () => {
  return (
    <div className="sub-nav">
      <ul>
        {menus.map((menu, index) => {
          if (menu.condition && menu.condition() === false) {
            return false;
          }

          const LinkComponent = menu.index ? IndexLink : Link;

          return (
            <li key={index}>
              <LinkComponent
                onlyActiveOnIndex={false}
                to={menu.to}
                activeClassName="active"
              >
                <FormattedMessage id={menu.title} />
              </LinkComponent>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ImportExportNav;



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/ImportExportNav.js